// F50 — one naming + download convention for frozen agreement documents (shared by every path).
// `<agreement_no>-<Unsigned|Signed>.pdf`; agreement_no already carries the version suffix for v>1 (SA-000014-V2).

export function agreementDocumentFilename(agreementNo, part) {
  const base = String(agreementNo || 'agreement').trim().replace(/[\\/:*?"<>|]+/g, '-');
  return `${base}-${part === 'signed' ? 'Signed' : 'Unsigned'}.pdf`;
}

export function filenameFromDisposition(header) {
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header || '');
  return m ? decodeURIComponent(m[1].trim()) : null;
}

export function resolveAgreementFilename(agreementNo, part, dispositionHeader) {
  return agreementNo ? agreementDocumentFilename(agreementNo, part) : (filenameFromDisposition(dispositionHeader) || agreementDocumentFilename('agreement', part));
}

export function downloadAgreementPdf(blobOrData, filename) {
  const blob = blobOrData instanceof Blob ? blobOrData : new Blob([blobOrData], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.rel = 'noopener'; a.style.display = 'none';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
  return filename;
}

export function openAgreementPdfPreview(blobOrData) {
  const blob = blobOrData instanceof Blob ? blobOrData : new Blob([blobOrData], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  if (!window.open(url, '_blank', 'noopener')) {
    const a = Object.assign(document.createElement('a'), { href: url, target: '_blank', rel: 'noopener' });
    document.body.appendChild(a); a.click(); a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
